import { Slider, SliderProps } from "../Slider";

export const MapList = ({ wrapper_props, ...props }: SliderProps) => {
  return (
    <Slider
      wrapper_props={{
        pos: "absolute",
        top: 0,
        bottom: 0,
        zIndex: 1,
        px: 4,
        pt: { base: 20, lg: 4 },
        gap: 4,
        w: "max-content",
        ...wrapper_props,
      }}
      options={{ direction: "ttb", autoHeight: true }}
      {...props}
    />
  );
};
